import {Injectable} from '@angular/core';
import {Capacitor} from '@capacitor/core';
import {Preferences} from '@capacitor/preferences';

export interface MobileStoredCredentials {
	email: string;
	password: string;
	rememberMe: boolean;
}

const CREDENTIALS_KEY = 'mobile_auth_credentials';

@Injectable({providedIn: 'root'})
export class MobileAuthCredentialsService {

	async save(credentials: MobileStoredCredentials): Promise<void> {
		if (!Capacitor.isNativePlatform()) {
			return;
		}
		await Preferences.set({
			key: CREDENTIALS_KEY,
			value: JSON.stringify(credentials),
		});
	}

	async getCredentials(): Promise<MobileStoredCredentials | null> {
		if (!Capacitor.isNativePlatform()) {
			return null;
		}
		const {value} = await Preferences.get({key: CREDENTIALS_KEY});
		if (!value) {
			return null;
		}
		try {
			return JSON.parse(value) as MobileStoredCredentials;
		} catch {
			return null;
		}
	}

	async clear(): Promise<void> {
		if (!Capacitor.isNativePlatform()) {
			return;
		}
		await Preferences.remove({key: CREDENTIALS_KEY});
	}

	async hasRememberedCredentials(): Promise<boolean> {
		const credentials = await this.getCredentials();
		return !!(credentials?.email && credentials?.password);
	}
}
